import React from "react";
import { connect } from "react-redux";
import { Actions as SCHEMEACTIONS } from "../../../store/actions/schemeActions";
import { XMarkIcon } from "@heroicons/react/20/solid";
import AddSchemeModal from "./AddSchemeModal";

const AddScheme = ({ setCloseSchemeModal, modalState, modalScheme }) => {
	if (!modalState) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{
				display: "block",
				background: "rgba(0,0,0,0.4)",
				overflow: "auto",
			}}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={setCloseSchemeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">{modalScheme ? "Edit" : "Add"} Scheme</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingLeft: "2rem", paddingRight: "2rem", paddingTop: 0 }}
						>
							<AddSchemeModal />
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		modalState: state?.pensions?.scheme?.modalState,
		modalScheme: state?.pensions?.scheme?.modalScheme,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setCloseSchemeModal: () => dispatch(SCHEMEACTIONS.setOpenSchemeModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddScheme);
